<template>
<div>
  <div class="background" @click="close">
  </div>
  <div class="modal">
    <div class="modal-header">
      <div class="button" @click="close">X</div>
      <h2>Schilderen onder hoogspanning</h2>
    </div>
    <div class="modal-body">
      <slide id="slide" :data="imagelist" :small="true"></slide>
      <div class="text">
        <p>
          Binnenkort gaan wij starten met de uitvoering van conserveringswerkzaamheden aan diverse hoogspanning verdeelstations. Deze verdeelstations worden geëxploiteerd door energiedistributiebedrijven en worden gebruikt voor het reduceren van hoogspanning (150.000 Volt) naar midden- en laagspanning.
        </p>
        <p>Hoogspanning verdeelstations bestaan voornamelijk uit transformatoren, schakelapparatuur, afspanportalen en bedrijfsgebouwen. Een juiste werking van deze componenten staat garant voor een ongestoorde verbinding tussen energiecentrale en eindgebruikers.</p>
        <p>Aan ons de taak deze componenten voor lange tijd te gaan beschermen tegen roestvorming. Met de inzet van ons vakmanschap en jarenlange ervaring alsmede met gebruik van ons equipement voor hogedruk reinigen, corrosiebestrijding en conservering gaan we deze uitdaging aan.</p>
        <p>De enorme koelersegmenten van de transformatoren worden geconserveerd met ijzerglimmerverf in gietkwaliteit. Voor de applicatie daarvan gebruiken we speciale pompensets. Afhankelijk van het type transformator kan het oppervlak van de koelersegmenten tot 1.000 vierkante meters bedragen.</p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Slide from '@/components/Slide.vue';
import Event from '@/event.js';
export default {
  name: 'ProjectModal',
  components: {Slide},
  data () {
    return {
      imagelist: ['Hoogspanning1.jpg', 'Hoogspanning2.jpg']
    }
  },
  methods: {
    close() {
      Event.$emit('close');
    },
    test() {
      console.log('click');
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/css/definitions';

  .background {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.589);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 0;
  }

  .modal {
    position: fixed;
    z-index: 1;
    background: $color-text-wh;
    width: 50%;
    height: 98%;
    //padding: 20px 50px;
    border: 5px solid $color-acc;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow-y: scroll;
    .modal-header {
      position: relative;
      padding: 10px;
      .button {
        font-size: 35px;
        background: transparent;
        position: absolute;
        top: 0;
        right: 5px;
        cursor: pointer;
      }
    }
    .modal-body {
      .text {
        padding-top: 3px;
        padding: 20px;
        text-align: left;
        color: black;
        p {
          padding: 5px;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .modal {
      height: 95%;
      width: 90%;
    }
  }
</style>

